import Tabs from '@/components/Tabs/Tabs';
import './home.less';
import { useEffect, useRef, useState } from 'react';
import uploadIcon from '@/assets/home/upload.png';
import { Upload } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { SDService, projectController } from '@/api';
import UploadProgress from '@/components/UploadProgress/UploadProgress';
import GLBViewer from '@/components/GLBViewer/GLBViewer';
import Uploader from '@/utils/uppyUpload';
import toast from 'react-hot-toast';
import { base64ToFile, fileExtension, isFormatFile, uploadFile } from '@/utils/file';
import ConfirmDialog from '@/components/ConfirmDialog/ConfirmDialog.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { setShowPricePage } from '@/store/slices/home.js';
import jsFunc from '@/utils/jsFunc';
import message, { info } from '@/utils/message';
import { reportData } from '@/utils/trackingPoint';
import { getImageSize } from '@/utils/image';

export default function Home() {
  const [tab, setTab] = useState(0);
  const [imageFileInfo, setImageFileInfo] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [meshFile, setMeshFile] = useState(null);
  const [showBanlanceModal, setShowBanlanceModal] = useState(false);
  const dispatch = useDispatch();

  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const glbViewerRef = useRef(null);

  const testTaskId = false; // 走测试id

  const navigate = useNavigate();

  useEffect(() => {
    // jsFunc.toastMsg(
    //   'addasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfa,addasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfa,addasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfa,addasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfaaddasdadadsjflsfa',
    // );
    // jsFunc.confirm({
    //   message: 'dadsadasda',
    //   cancelText: 'Cancel',
    //   confirmText: 'Confirm',
    //   cancelFunction: () => {},
    //   confirmFunction: () => {},
    // });
    const query = new URLSearchParams(window.location.search);
    const name = query.get('register');
    if (!window.reportDataGoogle) {
      if (name === 'true') {
        reportData('signup-google-success');
      } else if (name === 'false') {
        reportData('login-google-success');
      }
      window.reportDataGoogle = true;
    }
  }, []);

  const uploadImage = async () => {
    reportData('home-start-model');

    if (uploading) {
      info('Waiting for generation to complete');
      return;
    }
    if (!imageFileInfo) {
      info('Please choose file');
      return;
    }

    const startTime = new Date().getTime();
    try {
      setUploading(true);

      const coverimgResult = await uploadFile(imageFileInfo.file, 1);

      const fileExtension = imageFileInfo.file.name.split('.').pop().toLowerCase();

      let type = 0;
      if (fileExtension === 'png') {
        type = 3;
      } else if (fileExtension === 'jpeg' || fileExtension === 'jpg') {
        type = 4;
      }
      const res = await projectController.create({
        body: {
          name: imageFileInfo.file.name,
          type: 1, // ProjectTypeEnum
          mode: 'model_3d', // ConsumptionMode
          tempId: '',
          coverStream: {
            type: type, // streamType 0 OBJ 1 FBX 2 GLB 3 PNG 4 JPEG
            upload: {
              uploadId: coverimgResult.uploadId,
              completedParts: coverimgResult.eTags,
            },
          },
        },
      });

      console.log('本次创建项目总耗时(ms)', new Date().getTime() - startTime);

      if (res.code === 0) {
        // 创建成功
        const { projectId, cover } = res.data;

        const res3d = await SDService.submit_3d({
          imageUrl: cover,
          projectId: projectId,
          platformType: '1', // 0 是混元 1 是tripo
        });
        if (res3d.code === 0) {
          const task_id = res3d.data.task_id;

          const interval = setInterval(async () => {
            const taskRes = await SDService.task_status_3d(task_id);
            if (taskRes.code === 0) {
              const data = taskRes.data;
              const progress = data.progress;
              setProgress(progress);
              if (data.status === 'success') {
                clearInterval(interval);
                sessionStorage.setItem('preview_url', data.modelUrl);
                navigate('/preview/' + projectId);
                setUploading(false);
              }
            } else {
              clearInterval(interval);
            }
          }, 2000);
        } else {
          message.error(res3d.msg || 'System error', {
            id: 'only',
          });
        }
      } else if (res.code === -111) {
        // message.error('Insufficient balance, please recharge.', {
        //   id: 'only',
        // });
        setShowBanlanceModal(true);
        setUploading(false);
      } else if (res.code === -34) {
        message.error('System error', {
          id: 'only',
        });
      } else {
        message.error('System error', {
          id: 'only',
        });
      }
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  // 截图 -> base64
  const snapshotBase64 = (mime = 'image/png', quality) => {
    // 需要在 renderer 初始化时设置 preserveDrawingBuffer:true 才能截图
    const dataURL = document.getElementById('glbViewer').toDataURL(mime, quality); // 'data:image/png;base64,...'
    // 如果你只要纯 base64（无前缀）：
    const base64 = dataURL.split(',')[1];
    return { dataURL, base64 };
  };

  // 上传mesh
  const uploadMesh = async () => {
    reportData('home-start-texture');

    if (uploadLoading) {
      info('Waiting for generation to complete');
      return;
    }
    if (!meshFile) {
      info('Please choose file');
      return;
    }
    // navigate('/textureUnity');
    // return;
    const fileExtension = meshFile.name.split('.').pop();
    const fileName = meshFile.name.split('.')[0];
    const startTime = new Date().getTime();
    const coverimg = glbViewerRef.current.snapshotBase64();

    setUploadLoading(true);

    const modelResult = await uploadFile(meshFile, 0);

    const coverimgResult = await uploadFile(base64ToFile(coverimg, 'cover.jpg'), 1);

    const { uploadId, eTags } = modelResult;
    let type = 0;
    if (fileExtension === 'obj') {
      type = 0;
    } else if (fileExtension === 'fbx') {
      type = 1;
    } else if (fileExtension === 'glb') {
      type = 2;
    }

    const res = await projectController.create({
      body: {
        name: fileName,
        stream: {
          type: type, // StreamTypeEnum
          upload: {
            uploadId: uploadId,
            completedParts: eTags,
          },
          zIndex: 1,
        },

        type: 0, // ProjectTypeEnum
        mode: 'texture', // ConsumptionMode
        tempId: '',
        coverStream: {
          type: type, // streamType 0 OBJ 1 FBX 2 GLB 3 PNG 4 JPEG
          upload: {
            uploadId: coverimgResult.uploadId,
            completedParts: coverimgResult.eTags,
          },
        },
      },
    });
    console.log('本次创建项目总耗时(ms)', new Date().getTime() - startTime);

    if (res.code === 0) {
      // 创建成功
      reportData('upload-model-success');

      const { projectId, url } = res.data;
      console.log(res);
      sessionStorage.setItem('texture_model_url', url);
      setUploadLoading(false);
      window.location.href =
        window.location.protocol + '//' + window.location.host + '/texture/' + projectId;
    }
  };

  return (
    <div className="home">
      {/* <div className="downbg"></div>
      <div className="upbg"></div> */}
      <div className="caption">Let’s get started!</div>
      <div className="caption-desc">
        Ai-generated, creative-led-A fully controllable and editable 3D workflow
      </div>
      <Tabs
        tabs={['Generate 3D model', 'Generate Texture']}
        disabled={uploadLoading || uploading}
        onChange={(item, i) => {
          if (i == 1) {
            reportData('tab-generate-texture');
          } else {
            reportData('tab-generate-model');
          }
          setTab(i);
        }}></Tabs>
      {tab === 1 ? (
        <>
          <Upload
            beforeUpload={() => false}
            showUploadList={false}
            accept=".glb,.obj,.fbx"
            onChange={(info) => {
              reportData('upload-model');
              const isLt2M = info.file.size / 1024 / 1024 < 70;
              if (!isLt2M) {
                message.info('Please upload a file smaller than 70MB');
                return;
              }
              if (isFormatFile(info.file, ['.glb', '.obj', '.fbx'])) {
                setMeshFile(info.file);
              } else {
                message.info('Invalid format');
              }
            }}>
            {meshFile ? (
              <div className="texure-tab-content">
                <div className="texure-tab-content-glb">
                  <GLBViewer
                    key={meshFile.name}
                    ref={glbViewerRef}
                    format={fileExtension(meshFile.name)}
                    onLoadFinish={() => {}}
                    style={{ width: '100%', height: '100%' }}
                    url={URL.createObjectURL(meshFile)}></GLBViewer>
                </div>
                {uploadLoading ? (
                  <div className="texure-tab-content-upload">
                    <UploadProgress percent={progress} title="Uploading..."></UploadProgress>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <div className="texure-tab-content">
                <img className="icon" src={uploadIcon}></img>
                <div className="desc">
                  <span style={{ color: '#A0F00F', textDecoration: 'underline' }}>
                    Click to upload
                  </span>
                  <span> or drag and drop</span>
                </div>
                <div className="suffix">
                  <span>OBJ, FBX and GLB formats. Less than 70MB.</span>
                </div>
              </div>
            )}
          </Upload>
          <div
            className="upload-btn"
            onClick={() => {
              uploadMesh();
            }}>
            Generate
          </div>
        </>
      ) : (
        <>
          <Upload
            beforeUpload={() => false}
            showUploadList={false}
            accept=".jpg,.png,.jpeg"
            onChange={async (info) => {
              reportData('upload-image');
              console.log('info=', info);
              const isLt2M = info.file.size / 1024 / 1024 < 8;
              const size = await getImageSize(info.file);
              console.log('size', size);
              if (size.width > 6000 || size.width < 20 || size.height > 6000 || size.height < 20) {
                message.info('The width and height of the image must be within 20–6000.');
                return;
              }
              if (!isLt2M) {
                message.info('Please upload a file smaller than 8MB');
                return;
              }
              if (isFormatFile(info.file, ['.jpg', '.png', '.jpeg'])) {
                console.log('info', info);
                setImageFileInfo(info);
                setImageURL(URL.createObjectURL(info.file));
                reportData('upload-image-success');
              } else {
                message.info('Invalid format');
              }
            }}>
            <div className="texure-tab-content">
              {!imageFileInfo ? (
                <>
                  <img className="icon" src={uploadIcon}></img>
                  <div className="desc">
                    <span style={{ color: '#A0F00F', textDecoration: 'underline' }}>
                      Click to upload
                    </span>
                    <span> or drag and drop</span>
                  </div>
                  <div className="suffix">
                    <span>JPG,PNG formats. Less than 8MB.</span>
                  </div>
                </>
              ) : uploading ? (
                <UploadProgress percent={progress}></UploadProgress>
              ) : (
                <img className="upload-image" src={imageURL}></img>
              )}
            </div>
          </Upload>
          <div className="upload-btn" onClick={uploadImage}>
            Generate
          </div>
        </>
      )}
      {showBanlanceModal && (
        <ConfirmDialog
          confirmTitle="Confirm to recharge"
          content="Insufficient balance, please recharge."
          onConfirm={() => {
            dispatch(setShowPricePage(true));
            setShowBanlanceModal(false);
          }}
          onCancel={() => {
            setShowBanlanceModal(false);
          }}></ConfirmDialog>
      )}
    </div>
  );
}
